import { AdditionalInformationDto } from '@savgroup-front-common/types';

export function indexWithoutUniquenessByProduct() {
  return (
    acc: {
      counter: number;
      indexedNeededInformation: (AdditionalInformationDto & {
        internalId: string;
        claimIds: string[];
        fileUploadEndpoints?: {
          [key: string]: {
            uploadEndpoint: string;
            deleteEndpoint: string;
          };
        };
        index?: number;
        isEven: boolean;
      })[];
    },
    item: AdditionalInformationDto & {
      internalId: string;
      claimIds: string[];
      fileUploadEndpoints?: {
        [key: string]: {
          uploadEndpoint: string;
          deleteEndpoint: string;
        };
      };
    },
  ) => {
    const { counter } = acc;

    return {
      counter: counter + 1,
      indexedNeededInformation: [
        ...acc.indexedNeededInformation,
        {
          ...item,
          index: counter,
          isEven: counter % 2 === 0,
        },
      ],
    };
  };
}
